import set from 'lodash/set';
import { combineReducers } from 'redux';
import { createReducer } from 'redux-act';
import { resource, initialPurchaseState, UnexpectedLabelError } from './resource';
const updateStateForResource = transform => (state, payload) => ({
  ...state,
  [payload.purchaseId]: transform(state[payload.purchaseId] || initialPurchaseState(), payload)
});
const updateStateForCart = transform => (state, payload) => ({
  ...state,
  [payload.cartId]: transform(state[payload.cartId], payload)
});
const matchLabel = (action, matchers) => (state, payload) => {
  if (!payload.inAppPurchaseType) {
    throw new UnexpectedLabelError(action, payload);
  }
  const match = matchers[payload.inAppPurchaseType];
  if (!match) {
    throw new UnexpectedLabelError(action, payload);
  }
  return match(state, payload);
};
const parseProductErrors = errors => errors.reduce((acc, err) => {
  if (!('name' in err) || !('location' in err)) return acc;
  set(acc, err.name, err.description);
  if (err.location !== 'body' && !('_error' in acc)) {
    acc._error = err.description;
  }
  return acc;
}, {});
const convertProductApi = api => api;
const cartsReducer = createReducer({
  [resource.fetchOne.success.getType()]: updateStateForCart((state, payload) => payload.response.data),
  [resource.fetchOne.failure.getType()]: updateStateForCart((state, payload) => state)
}, {});
const purchasesReducer = createReducer({
  [resource.createOne.start.getType()]: matchLabel(resource.createOne.start, {
    'create-cart': updateStateForResource((state, payload) => ({
      cartId: undefined,
      products: [],
      errors: undefined,
      isFailure: false
    })),
    'create-product': updateStateForResource((state, payload) => state),
    'commit-cart': updateStateForResource((state, payload) => state)
  }),
  [resource.createOne.success.getType()]: matchLabel(resource.createOne.success, {
    'create-cart': updateStateForResource((state, payload) => ({
      ...state,
      cartId: payload.response.data.id
    })),
    'create-product': updateStateForResource((state, payload) => {
      const newProductsList = state.products.concat(convertProductApi(payload.response.data));
      if (payload.response.data.status === 'error') {
        return {
          ...state,
          products: newProductsList,
          errors: parseProductErrors(payload.response.data.errors),
          isFailure: true
        };
      }
      return {
        ...state,
        products: newProductsList
      };
    }),
    'commit-cart': updateStateForResource((state, payload) => ({
      cartId: undefined,
      products: [],
      errors: undefined,
      isFailure: false
    }))
  }),
  [resource.createOne.failure.getType()]: matchLabel(resource.createOne.failure, {
    'create-cart': updateStateForResource((state, payload) => ({
      ...state,
      errors: payload.error.errors,
      isFailure: true
    })),
    'create-product': updateStateForResource((state, payload) => ({
      ...state,
      errors: payload.error.errors,
      isFailure: true
    })),
    'commit-cart': updateStateForResource((state, payload) => ({
      ...state,
      errors: payload.error.errors,
      isFailure: true
    }))
  }),
  [resource.deleteOne.start.getType()]: matchLabel(resource.deleteOne.start, {
    'delete-cart': updateStateForResource((state, payload) => state)
  }),
  [resource.deleteOne.success.getType()]: matchLabel(resource.deleteOne.success, {
    'delete-cart': updateStateForResource((state, payload) => initialPurchaseState())
  }),
  [resource.deleteOne.failure.getType()]: matchLabel(resource.deleteOne.failure, {
    'delete-cart': updateStateForResource((state, payload) => ({
      ...state,
      isFailure: true,
      errors: payload.error.errors
    }))
  })
}, {});
const reducer = combineReducers({
  carts: cartsReducer,
  purchases: purchasesReducer
});
export default reducer;